import { createRequestTypes } from '../utils';

export const FETCH_SHADES = createRequestTypes('shade/FETCH_SHADES');
export const DELETE_SHADE = createRequestTypes('shade/DELETE_SHADE');
export const SAVE_SHADE = createRequestTypes('shade/SAVE_SHADE');
export const UPDATE_INCI = createRequestTypes('shade/UPDATE_INCI');
